import LMSDispatcher from "../LMSDispatcher";
import { IApi, Api } from '../../utilities/Api';
import { ApiRequest } from '../../utilities/ApiRequest';
import * as ACTIONCONSTANTS from './ActionConstants';
import notificationActions from "./NotificationActions";
import { IScope, IRoleData } from "../../models/rolesAndPermission/ScopeRoleEditData";
import * as CONSTANTS from "../../utilities/Constants";
import i18next from "i18next";

class RolesAndPermissionsActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONSTANTS.AUTH_ENDPOINT);
    }

    async getById(id: string) {
       
        try {
            const request = new ApiRequest("/Scopes/" + id, "", null, i18next.t("Role Scope not found."));
            const result = await this.api.get(request);
            const payload = result.data;
            LMSDispatcher.dispatch({
                type: ACTIONCONSTANTS.ROLE_GET_BY_ID,
                payload: {
                    roleData: payload
                }
            });
        } catch (error) {
            notificationActions.show({
                severity: "alarm",
                message: error.message
            }).then();
        }
    }

    async getAll() {
        try {
            const request = new ApiRequest("/Resources", "", null, i18next.t("Internal server error!"));
            const result = await this.api.get(request);
            const payload = result.data;
            LMSDispatcher.dispatch({
                type: ACTIONCONSTANTS.ROLE_GET_ALL,
                payload: {
                    roleDataList: payload
                }
            });
        } catch (error) {
            notificationActions.show({
                severity: "alarm",
                message: error.message
            }).then();
        }
    }

    async put(data: IScope[], roleData: IRoleData): Promise<void> {
        try {
            const payload: any = this.preparePutPayload(data, roleData);
            const request = new ApiRequest("/Scopes/" + roleData._id, "", payload, i18next.t("Permissions updated."));
            const result = await this.api.put(request);
            setTimeout(() => {
            LMSDispatcher.dispatch({
                type: ACTIONCONSTANTS.ROLE_EDIT,
                payload: {
                    data: result
                }
            });
            }, CONSTANTS.NOTIFICATION_TIMEOUT);
        } catch (error) {
            notificationActions.show({
                severity: "alarm",
                message: error.message
            }).then();
        }
    }

    private preparePutPayload(data: IScope[], roleData: IRoleData): any { 
        return{
            name: roleData.name,
            displayName: roleData.displayName,
            owner: {
                id: "",
                name: ""
            },
            scopes: data,
            _id: roleData._id
        }
    }
}

const rolesActions = new RolesAndPermissionsActions();
export default rolesActions;